import React from "react";

const DashFooter = () => {
  return (
    <footer
      className="w-[100%] bg-white  text-center text-sm text-gray-600 fixed bottom-0 lg:w-[78%] 
    lg:ml-[9%] xl:ml-[4.95%] xl:w-[82%] xl:h-8 xl:items-center xl:p-0"
    >
      Crafters Online Shop &copy; 2024
    </footer>
  );
};

export default DashFooter;
